import React, { useState } from "react";
import apiService from "../../services/apiService";
import { stepSummaryText } from "./dataPrepOps";

/** Always-visible summary of the cross-cutting Data Prep recipe — it stays
 * active while you switch between techniques, so this is the one place you
 * see everything queued up and can preview or clear it. */
function DataPrepRecipeStrip({ projectId, steps, onRemoveStep, onClear }) {
  const [preview, setPreview] = useState(null);
  const [previewing, setPreviewing] = useState(false);

  if (!steps || steps.length === 0) return null;

  const handlePreview = async () => {
    setPreviewing(true);
    setPreview(null);
    try {
      const { data } = await apiService.post("/analysis/prep/preview", { projectId, dataPrep: steps });
      setPreview(data);
    } catch (err) {
      setPreview({ error: err.message || "Preview failed." });
    } finally {
      setPreviewing(false);
    }
  };

  return (
    <div className="prep-recipe-strip">
      <div className="prep-recipe-header">
        <h5>Data Prep Recipe ({steps.length} step{steps.length === 1 ? "" : "s"}) — applies to every run below</h5>
        <div className="prep-recipe-actions">
          <button className="analysis-export-btn" onClick={handlePreview} disabled={previewing}>
            {previewing ? "Previewing..." : "Preview Effect"}
          </button>
          <button className="dv-clear-btn" onClick={() => { onClear(); setPreview(null); }}>Clear Recipe</button>
        </div>
      </div>
      <ul className="prep-recipe-list">
        {steps.map((s, i) => (
          <li key={i} className="prep-recipe-item">
            <span>{stepSummaryText(s)}</span>
            <button onClick={() => onRemoveStep(i)} aria-label="Remove step">&times;</button>
          </li>
        ))}
      </ul>
      {preview && (
        preview.error ? (
          <p className="prep-warning">{preview.error}</p>
        ) : (
          <p className="analysis-muted">
            Preview: {preview.rowCountBefore} rows → {preview.rowCountAfter} rows after prep.
          </p>
        )
      )}
    </div>
  );
}

export default DataPrepRecipeStrip;
